export enum UiStorageKey {
  AllowOfflineEdit = 'AllowOfflineEdit',
  BackupVersionsHashCode = 'backupVersionsHashCode',
  BetaSidepanelOff = 'BetaSidepanelOff', // TODO Remove after take statistic
  ComputersHiddenColumns = 'ComputersHiddenColumns',
  CustomizeDashboard = 'CustomizeDashboard',
  DashboardSelectedTag = 'DashboardSelectedTag',
  destinationAsDefault = 'destinationAsDefault',
  HidePasswordRecoveryModal = 'hidePasswordRecoveryModal',
  HidePasswordRecoveryComputersModal = 'hidePasswordRecoveryComputersModal',
  HideMainUserMenuBadge = 'hideMainUserMenuBadge',
  HideMSP2FAModal = 'hideMSP2FAModal',
  RmmVersionsHashCode = 'rmmVersionsHashCode',
  ShowOfflineEditBanner = 'ShowOfflineEditBanner',
  StoragesHiddenColumns = 'storagesHiddenColumns',
  FreeRmmLicense2024 = 'freeRmmLicense2024',
  LicensesHiddenColumns = 'licensesHiddenColumns'
}

export type UiStorageType = {
  [UiStorageKey.AllowOfflineEdit]?: string;
  [UiStorageKey.BackupVersionsHashCode]?: string;
  [UiStorageKey.BetaSidepanelOff]?: boolean; // TODO Remove after take statistic
  [UiStorageKey.ComputersHiddenColumns]?: string[];
  [UiStorageKey.CustomizeDashboard]?: string[];
  [UiStorageKey.DashboardSelectedTag]?: string;
  [UiStorageKey.destinationAsDefault]?: { [key:string]: string };
  [UiStorageKey.HideMainUserMenuBadge]?: 'true' | 'false';
  [UiStorageKey.HideMSP2FAModal]?: 'true' | 'false';
  [UiStorageKey.HidePasswordRecoveryModal]?: 'true' | 'false';
  [UiStorageKey.HidePasswordRecoveryComputersModal]?: 'true' | 'false';
  [UiStorageKey.RmmVersionsHashCode]?: string;
  [UiStorageKey.ShowOfflineEditBanner]?: 'true' | 'false';
  [UiStorageKey.ComputersHiddenColumns]?: string[];
  [UiStorageKey.CustomizeDashboard]?: string[];
  [UiStorageKey.StoragesHiddenColumns]?: string[] | string;
  [UiStorageKey.FreeRmmLicense2024]?: 1 | 2 | '1' | '2';
};
